/**
 * Fond étoilé.
 * - Désactivé sur TV (performances) et via Paramètres > Effets de fond.
 * - Anime une translation (GPU) au lieu de background-position, qui
 *   redessinait tout l'écran à chaque image.
 */
function AnimatedBackground({ disabled = false }) {
  if (disabled) return null

  return (
    <div className="animated-bg" aria-hidden="true">
      <div className="bg-gradient"></div>
      <div className="stars"></div>
    </div>
  )
}

export default AnimatedBackground
